module.exports = __webpack_public_path__ + "static/media/perro_big.0cc738c2.png";